<template>
	<router-view />
</template>

<script>
export default {
	name: 'mycelium',
};
</script>